import { queryOptions } from '@tanstack/react-query';
import { listBranches, listDealProducts, listDeals } from './deals.service';
import type { DealListParams, DealProductLookupParams } from './types';

export const dealsQueryKeyPrefix = ['merchant', 'deals'] as const;
export const branchesQueryKey = ['merchant', 'branches'] as const;

export function dealsQueryOptions(params: DealListParams = {}) {
  return queryOptions({
    queryKey: [
      ...dealsQueryKeyPrefix,
      params.status ?? null,
      params.branch_id ?? null,
      params.deal_type ?? null,
    ],
    queryFn: () => listDeals(params),
    staleTime: 30_000,
  });
}

export function branchesQueryOptions() {
  return queryOptions({
    queryKey: branchesQueryKey,
    queryFn: listBranches,
    staleTime: 5 * 60_000,
  });
}

export function dealProductsQueryOptions(params: DealProductLookupParams) {
  return queryOptions({
    queryKey: [
      'merchant',
      'deal-products',
      params.q ?? null,
      params.branch_id ?? null,
      params.page ?? null,
      params.page_size ?? null,
    ],
    queryFn: () => listDealProducts(params),
    staleTime: 30_000,
  });
}
